import { ACTIVE, IN_ACTIVE, SUNSET, PLANNED } from "../consts/inventoryStatus"
import { useState } from 'react'

export const getStatusColor = (status) => {
    switch(status) {
        case ACTIVE: 
            return 'bg-green-100 text-green-800'
        case IN_ACTIVE:
            return 'bg-gray-100 text-gray-800'
        case SUNSET:
            return 'bg-yellow-100 text-yellow-800'
        case PLANNED:
            return 'bg-blue-100 text-blue-800'
        default:
            return 'bg-gray-100 text-gray-800'
    }
}

export const StatusSelect = ({
    handleStatusChange,
    onChange,
    access,
    idItem,
    currentStatus,
    isDisabled
}) => {
    const [status, setStatus] = useState(currentStatus);

    const onStatusChange = (e) => {
        if (access === "edit") {
            const newStatus = e.target.value;
            setStatus(newStatus);
            onChange?.(newStatus);
            handleStatusChange?.(idItem, newStatus);
        }
    };

    return (
        <select
            value={status}
            onChange={onStatusChange}
            className={`text-xs rounded w-24 border-gray-300 py-1 px-2 focus:ring-blue-500 focus:border-blue-500 ${
                getStatusColor(status)
            }`}
            disabled={isDisabled || access !== "edit"}
            aria-label="Change product status"
        >
            <option value={ACTIVE}>Active</option>
            <option value={IN_ACTIVE}>Inactive</option>
            <option value={SUNSET}>Sunset</option>
            <option value={PLANNED}>Planned</option>
        </select>
    )
}